import React from 'react';
import Contents from '../../components/Contents';
import AppLayout from '../../layouts/AppLayout';
import './styles.css';

function ContentsPage() {
  return (
    <AppLayout title="Conteúdos" subtitle="Biblioteca e edição" fullWidth>
      <Contents />
    </AppLayout>
  );
}

export default ContentsPage;
